import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { ArrowTopRightIcon } from '@radix-ui/react-icons';
import { PATH_CONTACT, STRIPE_LOGIN_URL } from '@/constants';
import { StripeSMIcon } from '@/components/ui/icons';
import ViewCredit from '../view-credit';

const Overview = () => {
  return (
    <>
      <div className="flex flex-col divide-y *:py-6 first:*:pt-0 last:*:pb-0">
        <div className="space-y-6">
          <ViewCredit isShowTopupButton />
        </div>

        <div className="flex flex-col gap-8">
          <p className="text-lg font-medium">Payment Setting</p>
          <div className="grid gap-2 sm:grid-cols-2">
            <div className="flex flex-col gap-1">
              <p className="text-base font-medium">Customer Management</p>
              <div className="flex flex-col items-start">
                <span className="text-muted-foreground">
                  You can pay via credit/debit card by setting up your payment
                  method in Stripe.
                  <br /> For bank transfers, invoices, receipts, or others
                  please contact support@float16.cloud.
                </span>
              </div>
            </div>
            <Link
              to={STRIPE_LOGIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2"
            >
              <Button
                variant={'outline'}
                startIcon={<StripeSMIcon className="h-6 w-6" />}
                endIcon={<ArrowTopRightIcon />}
                className="w-fit"
              >
                Go to Stripe
              </Button>
            </Link>
          </div>
          <div className="grid gap-2 sm:grid-cols-2">
            <div className="flex flex-col gap-1">
              <p className="text-base font-medium">Need Help?</p>
              <p className="text-muted-foreground">
                For billing inquiries or assistance with your account, please
                contact support.
              </p>
            </div>
            <Link
              to={PATH_CONTACT.support}
              target="_blank"
              rel="noopener noreferrer"
              className="w-fit"
            >
              <Button variant={'link'} endIcon={<ArrowTopRightIcon />}>
                Contact Support
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Overview;
